import xhr from './../../utils/xhr';
import {
    EXPERIAN_DELINQUENCY_STRINGS,
    EXPERIAN_STABILITY_STRINGS
} from '../../constants';
import reduxStore from '../../reduxStore';

const createAlertApi = {

    validateNameField: (alertName, alertId) => {

        let payload = {name: alertName};

        if (alertId) {
            payload['id'] = alertId;
        }

        return xhr.post({
            url:  '/api/alerts/duplicateName/',
            data: payload
        })

    },

    validateEmailAddress(emailsArr) {
        let trimmedEmailsArr = emailsArr;
        trimmedEmailsArr = trimmedEmailsArr.map(el => el.trim());
        return xhr.post({
            url: '/api/alerts/areUnsubscribed/',
            data: trimmedEmailsArr
        })
    },

    saveAlert: (alertData, alertId, isNewAlert) => {

        let createAlertExperianFeatureToggle = reduxStore.getState().user.appSettings.isExperianEnabled;

        let thirdParties = alertData.thirdParty.selectedThirdPartiesIds;
        let alertDataEmails = alertData.emails.split(',').map(el => el.trim());

        let createAlertPayload = {
            id:              alertId,
            active:          alertData.active,
            name:            alertData.name,
            alertFilterMeta: {
                selectAllThirdParties: alertData.thirdParty.thirdPartySelection === 'all-third-parties-section',
                categories:            alertData.thirdParty.selectedCategories,
                thirdParties:          alertData.thirdParty.thirdPartySelection === 'specific-third-parties-section' ?
                                           thirdParties : [],
                riskLevels:            alertData.riskAngles
            },
            newsActive:      alertData.isNewsAlertsActive,
            swActive:        alertData.isSwActive,
            experianActive:  createAlertExperianFeatureToggle ? alertData.isExperianActive : false,
            experianMeta:    {
                delinquencyRiskType: EXPERIAN_DELINQUENCY_STRINGS[alertData.experianRiskAngles.delinquencyRisk],
                stabilityRiskType:  EXPERIAN_STABILITY_STRINGS[alertData.experianRiskAngles.stabilityRisk]
            },
            recipientData:   {
                emails:       alertDataEmails,
                deliveryType: alertData.sendAs,
                attachType:   alertData.sendAs === 'INLINE' ? null : alertData.format,
            },
            scheduleMeta:    {
                frequency: alertData.frequency
            }
        };

        let customXhr = isNewAlert ? xhr.post : xhr.put;

        return customXhr({
            url:  '/api/alerts/alert',
            data: createAlertPayload
        })

    }

};

export default createAlertApi;


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/CreateAlertPage.api.js